/**
 * Live event binding on document or different context
 *
 * delegate('click', '.some_elem', document, (event) => {
 * });
 *
 * @param   {string} eventName Event to bind
 * @param   {string} sel Selector for the descendant node
 * @param   {Object} el Context the event node is related to
 * @param   {function} handler Callback function shoulkd get triggered when event gets triggered
 * @returns {void}
 */
export default (eventName, sel, el, handler) => {
  el.addEventListener(
    eventName,
    e => {
      const found = e.target.closest(sel);
      // returns null if no matching parentNode is found
      if (found) {
        handler.call(found, e);
      }
    },
    false
  );
};
